import React, { useState, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
//import { useTheme } from '@material-ui/core/styles'
import ReactBSAlert from 'react-bootstrap-sweetalert'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import Select from '@mui/material/Select'
import MenuItem from '@material-ui/core/MenuItem'
import AllocationTable from 'components/admin/AllocationTable'
import AdminAPI from 'config/api/AdminAPI'
import EnergyAPI from 'config/api/EnergyAPI'
import { onError } from 'config/lib/errorLib'
import moment from 'moment-timezone'

//import componentStyles from 'assets/theme/views/admin/notifications.js'
import componentStylesDialog from 'assets/theme/components/dialog.js'
import componentStylesForms from 'assets/theme/components/forms.js'
import componentStylesButtons from 'assets/theme/components/button.js'

//const useStyles = makeStyles(componentStyles)
const useStylesDialog = makeStyles(componentStylesDialog)
const useStylesForms = makeStyles(componentStylesForms)
const useStylesButtons = makeStyles(componentStylesButtons)

const Transition = React.forwardRef(function Transition(props, ref) {
  	return <Slide direction='down' ref={ref} {...props} />
})

export default function PaymentModal(props) {
	const classes = { ...useStylesDialog(), ...useStylesForms(), ...useStylesButtons() }
  	//const theme = useTheme()
  	const api = new AdminAPI()
    const eApi = new EnergyAPI()

    const payment = props.payment
    console.log('payment: ', payment)
    //const companies = props.companies

    // Detect if any product in the allocation was billed at cap (surge) rather than actual
    const isCapBased = payment.allocation && Object.values(payment.allocation).some(v => v.hasOwnProperty('actualDelivered'));

    //const [company, setCompany] = useState(payment.companyId)
    const [date, setDate] = useState(payment.date)
    const [billingMethod, setBillingMethod] = useState(payment.billingMethod)
    const [billingAccount, setBillingAccount] = useState(payment.billingAccount)
    const [billingPeriod, setBillingPeriod] = useState(payment.billingPeriod)
    const [vatRate, setVatRate] = useState(payment.vatRate)
    //const [description, setDescription] = useState(payment.description)
    const [allocation, setAllocation] = useState(payment.allocation || null)
    const [billingType, setBillingType] = useState(isCapBased ? 'allocation' : 'actual')
    const [subtotal, setSubtotal] = useState(payment.subtotal)
    const [total, setTotal] = useState(payment.total)
    const [amountPaid, setAmountPaid] = useState(payment.amountPaid || 0)
    const [status, setStatus] = useState(payment.status || 'n/a')
    const [notes, setNotes] = useState(payment.notes)
    const [reference, setReference] = useState(payment.reference || '')
    const [alert, setAlert] = useState(false)
    
    // Apply the selected billing type to every product line. 'allocation' stamps
    // the allocation-based markers (used by the pending list badge and cap billing);
    // 'actual' strips them so the invoice is treated as billed on leads delivered.
    // Re-applied on save because editing the allocation table drops these markers.
    function applyBillingType(alloc, type) {
        if (!alloc) return alloc
        const out = {}
        for (const [product, values] of Object.entries(alloc)) {
            if (type === 'allocation') {
                out[product] = {
                    ...values,
                    isAllocationBased: true,
                    actualDelivered: values.hasOwnProperty('actualDelivered') ? values.actualDelivered : values.allocation
                }
            } else {
                const { isAllocationBased, actualDelivered, ...rest } = values
                out[product] = rest
            }
        }
        return out
    }

    async function updatePayment() {
        try {
            try {   
                let totalPaid = status === 'paid' ? total : amountPaid
                console.log('totalPaid: ', totalPaid)
                const finalAllocation = applyBillingType(allocation, billingType)
                let updatedPayment = props.product === 'Financial' ? await api.updatePayment(payment.companyId, payment.date, billingAccount, vatRate, finalAllocation, subtotal, total, status, notes, reference, totalPaid) : await eApi.updatePayment(payment.companyId, payment.date, billingAccount, vatRate, finalAllocation, subtotal, total, status, notes, reference, totalPaid) 
                console.log('payment: ', updatedPayment)

                // Pass updated payment object only; parent supplies product context separately
                props.updatePayment(updatedPayment)
                props.showSuccessAlert('Payment updated!')
                props.close()
            } catch(e) {
                onError(e)
            }
  		} catch(e) {
  			onError(e)
  		}
    }

    async function deletePayment() {
        try {
            try {   
                if (props.product === 'Financial') {
                    await api.deletePayment(payment.companyId, payment.date)
                }
                else {
                    await eApi.deletePayment(payment.companyId, payment.date)
                }

                props.refreshPayments()
                props.showSuccessAlert('Payment deleted!')
                props.close()
            } catch(e) {
                onError(e)
            }
  		} catch(e) {
  			onError(e)
  		}
    }

    function showDeleteWarning() {
        setAlert(
            <ReactBSAlert
                warning
                style={{ display: 'block', marginTop: '-100px' }}
                title='Are you sure?'
                onConfirm={() => deletePayment()}
                onCancel={() => setAlert(false)}
                cancelBtnCssClass='btn-secondary'
                confirmBtnBsStyle='danger'
                cancelBtnText='Cancel'
                confirmBtnText='Yes, delete it'
                showCancel
                btnSize=''
            >
                This will remove the invoice permanently.
            </ReactBSAlert>
        )
    }

    function updateAllocation(allocation) {
        let subtotal = 0
        for (const [product, values] of Object.entries(allocation)) {
            // Source-priced products carry a per-source breakdown; sum each source
            // at its own price so editing another line can't collapse the split
            // to the blended base price.
            if (values.sourceBreakdown && Object.keys(values.sourceBreakdown).length) {
                for (const b of Object.values(values.sourceBreakdown)) {
                    subtotal += (b.count || 0) * (b.leadPrice || 0)
                }
            } else if (values.tierBreakdown && Object.keys(values.tierBreakdown).length) {
                // Variable-priced pensions carry a per-band breakdown; sum each band
                // at its own price so editing another line can't collapse the tiers.
                for (const b of Object.values(values.tierBreakdown)) {
                    subtotal += (b.count || 0) * (b.leadPrice || 0)
                }
            } else {
                subtotal += (values.allocation * values.leadPrice)
            }
        }
        subtotal = parseFloat(subtotal.toFixed(2))
        let total = subtotal + (subtotal * vatRate)
        total = parseFloat(total.toFixed(2))
        setAllocation(allocation)
        setSubtotal(subtotal)
        setTotal(total)
    }

    function updateVatRate(vatRate) {
        let total = subtotal + (subtotal * vatRate)
        total = parseFloat(total.toFixed(2))
        setVatRate(vatRate)
        setTotal(total)
    }

	return (
        <Dialog
            open={props.isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => props.close()}
        >
            {alert}
            <div className={classes.dialogHeader}>
				<Typography
					variant='h5'
					component='h5'
					className={classes.dialogTitle}
				>
					Update Invoice
				</Typography>
				<IconButton onClick={() => props.close()}>
					<Clear />
				</IconButton>
			</div>
            <DialogContent>
                <FormGroup>
                    <FormLabel>Company</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <OutlinedInput
                            fullWidth
                            type='text'
                            value={payment.companyName}
                            disabled={true}
                        />
                    </FormControl>
                </FormGroup>
				<FormGroup>
                    <FormLabel>Date</FormLabel>
                    <OutlinedInput
                        fullWidth
                        type='date'
                        value={date}
                        defaultValue={date}
                        onChange={(e) => setDate(e.target.value)}
                        disabled
                    />
                </FormGroup>
                <FormGroup>
                    <FormLabel>Reference (Xero Invoice)</FormLabel>
                    <OutlinedInput
                        fullWidth
                        type='text'
                        value={reference}
                        onChange={(e) => setReference(e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <FormLabel>Billing Method</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            //IconComponent={KeyboardArrowDown}
                            value={billingMethod}
                            onChange={(e) => setBillingMethod(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                            disabled
                        >
                            <MenuItem value='INV'>INV</MenuItem>
                            <MenuItem value='DD'>DD</MenuItem>
                            <MenuItem value='TOPUP'>TOPUP</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Billing Account</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            //IconComponent={KeyboardArrowDown}
                            value={billingAccount}
                            onChange={(e) => setBillingAccount(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value='BQ'>BQ</MenuItem>
                            <MenuItem value='SS'>SS</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Billing Period</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            //IconComponent={KeyboardArrowDown}
                            value={billingPeriod}
                            onChange={(e) => setBillingPeriod(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                            disabled
                        >
                            <MenuItem value='Weekly'>Weekly</MenuItem>
                            <MenuItem value='Monthly'>Monthly</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>VAT Rate</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={vatRate}
                            onChange={(e) => updateVatRate(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={0.23}>23% Exclusive (not included in lead price)</MenuItem>
                            <MenuItem value={0}>0% (no VAT)</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Billing Type</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            value={billingType}
                            onChange={(e) => setBillingType(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.25rem'}}
                        >
                            <MenuItem value='actual'>Actual (billed on leads delivered)</MenuItem>
                            <MenuItem value='allocation'>Allocation (billed at weekly cap)</MenuItem>
                        </Select>
                    </FormControl>
                    <Box fontSize='11px' color='#8898aa' marginBottom='0.5rem'>
                        Allocation = billed at the weekly cap (surge). Actual = billed on leads delivered.
                    </Box>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Allocation</FormLabel>
                    <AllocationTable 
                        allocations={allocation} 
                        updateAllocations={(allocation) => updateAllocation(allocation)}
                        product={props.product}
                    />
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Subtotal (€)</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                        value={subtotal}
                    	//onChange={(e) => setSubtotal(e.target.value)}
                        disabled
                  	/>
                </FormGroup>      
                <FormGroup>
                  	<FormLabel>Total (€)</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                        value={total}
                    	//onChange={(e) => setTotal(e.target.value)}
                        disabled
                  	/>
                </FormGroup>   
                {/* <FormGroup>
                    <FormLabel>Invoiced</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            //IconComponent={KeyboardArrowDown}
                            value={invoiced}
                            onChange={(e) => setInvoiced(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup> */}
                <FormGroup>
                    <FormLabel>Amount Paid</FormLabel>
                    <OutlinedInput
                    	fullWidth
                    	type='number'
                        value={amountPaid}
                    	onChange={(e) => setAmountPaid(e.target.value)}
                        //disabled
                  	/>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Status</FormLabel>
                    <FormControl variant='outlined' fullWidth>
                        <Select
                            multiple={false}
                            //IconComponent={KeyboardArrowDown}
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            input={<OutlinedInput />}
                            style={{marginBottom: '0.5rem'}}
                        >
                            <MenuItem value={'pending'}>Pending</MenuItem>
                            <MenuItem value={'invoiced'}>Invoiced</MenuItem>
                            <MenuItem value={'paid'}>Paid</MenuItem>
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Notes</FormLabel>
                  	<OutlinedInput
                    	fullWidth
                    	type='text'
                        value={notes}
                    	onChange={(e) => setNotes(e.target.value)}
                        multiline
                        minRows={2}
                  	/>
                </FormGroup>
                <FormGroup>
                  	<FormLabel>Email History</FormLabel>
                    {(payment.emails && payment.emails.length > 0) ? (
                        <>
                            {payment.emails.reverse().map((email) => {
                                return <p className='normal-text'>{moment(email.timestamp).format('DD/MM HH:mm')}</p>
                            })}
                        </>
                    ) : (
                        <p className='normal-text'>No emails logged</p>
                    )}
                </FormGroup>
                <Box>
                    <Typography className='hover-text red-text' style={{fontWeight: '400', fontSize: '1rem'}} onClick={() => showDeleteWarning()}>Delete Invoice</Typography>
                </Box>
			</DialogContent>
            <DialogActions>
                <Box width='100%' display='flex' justifyContent='space-between'>
                    <Button onClick={() => props.close()} color='primary'>
                        Close
                    </Button>
                    <Box>
                        <Box display='inline-block' marginRight='0.5rem'>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => updatePayment()}
                            >
                                Save
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </DialogActions>
        </Dialog>
	)
}